export const guestbook={
	'new-id':0, 
	'loaded':false, 
	'post-id':0, 
	'new-post':{
		name:'', 
		input:'', 
	}, 
	permission:{
		delete:window.MSWPGB_vars.delete, 
	}, 
	blur:{
		input:true, 
		'text-area':true, 
	}
};

export const SendNewPost=(data)=>{
	return RequestFetch({
		action:'ms-wpgb_new-post', 
		name:data.name, 
		post:data.input, 
		type:data.type, 
		pid:data.pid, 
	});
}

export const DeletePost=(data)=>{
	return RequestFetch({
		action:'ms-wpgb_delete-post', 
		type:'delete', 
		pid:data.pid, 
	});
}

export const QueryPost=(intPage)=>{
	return RequestFetch({
		action:'ms-wpgb_query-post', 
		page:intPage
	});
};

const RequestFetch=async(data)=>{
	const url=window.MSWPGB_vars.ajax_url;
	const param=new URLSearchParams(data);
	const settings={
		method:'POST', 
		body:param.toString(), 
		cache:'no-cache', 
		headers:{
			'Content-Type':'application/x-www-form-urlencoded; charset=utf-8'
		}
	};
	const res=await fetch(url, settings);
	return res.json();
};

export const StringAvatar=(name)=>{

	// console.log(name.split(' ')[0][0]);
	// if(name.indexOf(' ')<0)name=name+' 　';

	let children=name.indexOf(' ')<0?`${name.split(' ')[0][0]}`:`${name.split(' ')[0][0]}${name.split(' ')[1][0]}`;

	return {
		sx:{
			bgcolor:StringToColor(name),
		},
		// children:`${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
		// children:`${name.split(' ')[0][0]}`
		children:children
	};
}
const StringToColor=(string)=>{
	let hash=0, i;
	/* eslint-disable no-bitwise */
	for(i=0; i<string.length; i+=1) {
		hash=string.charCodeAt(i)+((hash<<5)-hash);
	}
	let color='#';
	for(i=0; i<3; i+=1) {
		const value=(hash>>(i*8))&0xff;
		color+=`00${value.toString(16)}`.slice(-2);
	}
	/* eslint-enable no-bitwise */
	// console.log(color);
	return color;
}
